export default {
    cognito: {
      REGION: "eu-west-2",
      USER_POOL_ID: "eu-west-2_eBwvXlEI5",
      APP_CLIENT_ID: "6dler302q6jcie3msik7k7vssp",
      IDENTITY_POOL_ID: "eu-west-2:daba6921-9da9-45ff-82d6-658606ec41bf"
    }
  };